module.exports = __webpack_public_path__ + "img/CleanWeek.275f4370.jpeg";